import Highcharts from './_highcharts-base';
import {Options} from 'highcharts';

export default function () {
    $(() => {
        for (const chart of $('.norm-chart')) {
            const options: Options = {
                yAxis: {
                    gridLineDashStyle: 'LongDash',
                    plotLines: [
                        {
                            value: 25,
                            color: 'black',
                            width: 1,
                            zIndex: 1,
                        }, {
                            value: 35,
                            color: 'black',
                            width: 1,
                            zIndex: 1,
                        }, {
                            value: 45,
                            color: 'black',
                            width: 1,
                            zIndex: 1,
                        }, {
                            value: 55,
                            color: 'black',
                            width: 1,
                            zIndex: 1,
                        }, {
                            value: 65,
                            color: 'black',
                            width: 1,
                            zIndex: 1,
                        }, {
                            value: 75,
                            color: 'black',
                            width: 1,
                            zIndex: 1,
                        }
                    ],
                    plotBands: [
                        {
                            color: '#f3f3f4',
                            from: 25,
                            to: 35,
                        }, {
                            color: '#d2d3d5',
                            from: 35,
                            to: 45,
                        }, {
                            color: '#a5a6aa',
                            from: 45,
                            to: 55,
                        }, {
                            color: '#d2d3d5',
                            from: 55,
                            to: 65,
                        }, {
                            color: '#f3f3f4',
                            from: 65,
                            to: 75,
                        }
                    ]
                },
                xAxis: {
                    labels: {
                        useHTML: true,
                        style: {
                            fontSize: '10pt',
                            color: 'black'
                        }
                    },
                    lineColor: 'black',
                    tickWidth: 0,
                },
                plotOptions: {
                    columnrange: {
                        grouping: false,
                    },
                },
            };
            new Highcharts.Chart(
                chart,
                $.extend(true, {}, options, $(chart).data('chart'))
            );
        }
    });
}